"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { BlogPanel } from "./BlogPanel";
import BlogFilters from "./BlogFilters";
import { useState } from "react";
import { FilterOption } from "./BlogFilters";
import { normalizeTabType } from "@/lib/center/centerTags";
import { compareResourceGridByDate } from "@/lib/resourceGrid/sortResourceGridCards";
type Props = {
  id: string;
  displayName: string;
  index: number;
  filters: any;
  activeTab: number;
  typeToGather: string[];
  allCards?: object[];
  config?: any;
  loadMoreText?: string;
  mainCardFilters?: FilterOption[];
  lang?: string;
  cardDisplayMode?: string;
};
export default function ResourceGridTab(t0) {
  const $ = _c(60);
  const {
    filters,
    activeTab,
    typeToGather,
    allCards,
    config,
    mainCardFilters,
    lang,
    cardDisplayMode
  } = t0;
  const labelSortByLabel = config?.commonDefaultValues?.labelForSortBy || "Sort By";
  const newestLabel = config?.commonDefaultValues?.labelForNewest || "Newest";
  const oldestLabel = config?.commonDefaultValues?.labelForOldest || "Oldest";
  const loadMoreLabel = config?.commonDefaultValues?.labelForLoadMoreResults || "Load More";
  const labelNoResults = config?.commonDefaultValues?.labelForNoResults || "No Results";
  const labelForClearAll = config?.commonDefaultValues?.labelForClearAll || "Clear All";
  let t1;
  if ($[0] !== newestLabel) {
    t1 = [{
      title: newestLabel,
      id: newestLabel
    }];
    $[0] = newestLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedSorting, setSelectedSorting] = useState(t1);
  const [showLoadMore, setShowLoadMore] = useState(true);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [selectedFilters, setSelectedFilters] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [tabCards, setTabCards] = useState(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [formattedCards, setFormattedCards] = useState(t4);
  let t5;
  if ($[5] !== newestLabel || $[6] !== oldestLabel) {
    t5 = [newestLabel, oldestLabel];
    $[5] = newestLabel;
    $[6] = oldestLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const sortingOptions = t5;
  const [cardLimit, setCardLimit] = useState(18);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = selected => {
      setSelectedFilters(selected);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleFilterChange = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = selected_0 => {
      setSelectedSorting(selected_0);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleSortingChange = t7;
  let t8;
  if ($[10] !== selectedFilters) {
    t8 = item => {
      setSelectedFilters(selectedFilters?.filter(selectedFilter => selectedFilter?.id !== item?.id));
    };
    $[10] = selectedFilters;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleChipDelete = t8;
  const formattedCardTags = _temp2;
  const checkGridCardType = _temp5;
  let t9;
  if ($[12] !== allCards || $[13] !== cardDisplayMode || $[14] !== mainCardFilters || $[15] !== typeToGather) {
    t9 = () => {
      const typeFilteredCards = allCards?.filter(card_1 => checkGridCardType(typeToGather, card_1));
      const formattedFilteredCards = typeFilteredCards?.map(card_2 => {
        card_2.cardTags = formattedCardTags(card_2);
        return card_2;
      })?.filter(card_3 => {
        const shallowTabFilters = mainCardFilters?.map(_temp6).filter(Boolean) ?? [];
        const shallowCardTags = card_3?.cardTags?.map(_temp7).filter(Boolean) ?? [];
        if (shallowTabFilters.length === 0) {
          return true;
        }
        if (cardDisplayMode === "OR") {
          return shallowTabFilters.some(item_0 => shallowCardTags.includes(item_0));
        }
        return shallowTabFilters.every(item_1 => shallowCardTags.includes(item_1));
      });
      setFormattedCards(formattedFilteredCards);
    };
    $[12] = allCards;
    $[13] = cardDisplayMode;
    $[14] = mainCardFilters;
    $[15] = typeToGather;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = allCards?.length;
  let t11;
  if ($[17] !== allCards || $[18] !== cardDisplayMode || $[19] !== mainCardFilters || $[20] !== t10 || $[21] !== typeToGather) {
    t11 = [allCards, t10, mainCardFilters, typeToGather, cardDisplayMode];
    $[17] = allCards;
    $[18] = cardDisplayMode;
    $[19] = mainCardFilters;
    $[20] = t10;
    $[21] = typeToGather;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  useEffect(t9, t11);
  let t12;
  if ($[23] !== cardLimit || $[24] !== formattedCards || $[25] !== oldestLabel || $[26] !== selectedFilters || $[27] !== selectedSorting) {
    t12 = () => {
      const returnFilteredCards = _temp10;
      if (formattedCards) {
        let cards_0 = formattedCards;
        if (selectedFilters?.length > 0) {
          cards_0 = returnFilteredCards(cards_0, selectedFilters);
        }
        const sortDirection = selectedSorting[0]?.title === oldestLabel ? "oldest" : "newest";
        const sortedCards = cards_0?.slice().sort((a, b) => compareResourceGridByDate(a, b, sortDirection));
        const limitedCards = sortedCards?.slice(0, cardLimit);
        if (sortedCards?.length <= cardLimit) {
          setShowLoadMore(false);
        } else {
          setShowLoadMore(true);
        }
        setTabCards(limitedCards);
      }
    };
    $[23] = cardLimit;
    $[24] = formattedCards;
    $[25] = oldestLabel;
    $[26] = selectedFilters;
    $[27] = selectedSorting;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const t13 = formattedCards?.length;
  let t14;
  if ($[29] !== cardLimit || $[30] !== formattedCards || $[31] !== oldestLabel || $[32] !== selectedFilters || $[33] !== selectedSorting || $[34] !== showLoadMore || $[35] !== t13) {
    t14 = [selectedFilters, selectedSorting, cardLimit, formattedCards, t13, showLoadMore, oldestLabel];
    $[29] = cardLimit;
    $[30] = formattedCards;
    $[31] = oldestLabel;
    $[32] = selectedFilters;
    $[33] = selectedSorting;
    $[34] = showLoadMore;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  useEffect(t12, t14);
  let t15;
  if ($[37] !== cardLimit) {
    t15 = () => {
      setCardLimit(cardLimit + 18);
    };
    $[37] = cardLimit;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const loadMoreHandler = t15;
  let t16;
  if ($[39] !== filters) {
    t16 = filters || [];
    $[39] = filters;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== handleChipDelete || $[42] !== labelForClearAll || $[43] !== labelSortByLabel || $[44] !== selectedFilters || $[45] !== selectedSorting || $[46] !== sortingOptions || $[47] !== t16) {
    t17 = <BlogFilters gridFilters={t16} selectedFilters={selectedFilters} sortingOptions={sortingOptions} labelSortBy={labelSortByLabel} labelClearAll={labelForClearAll} handleFilterChange={handleFilterChange} handleSortingChange={handleSortingChange} selectedSorting={selectedSorting} setSelectedSorting={setSelectedSorting} handleChipDelete={handleChipDelete} />;
    $[41] = handleChipDelete;
    $[42] = labelForClearAll;
    $[43] = labelSortByLabel;
    $[44] = selectedFilters;
    $[45] = selectedSorting;
    $[46] = sortingOptions;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== activeTab || $[50] !== labelNoResults || $[51] !== lang || $[52] !== loadMoreHandler || $[53] !== loadMoreLabel || $[54] !== showLoadMore || $[55] !== tabCards) {
    t18 = <BlogPanel cards={tabCards} activeTab={activeTab} loadMoreText={loadMoreLabel} loadMoreHandler={loadMoreHandler} showLoadMore={showLoadMore} imageType="asImage" noResultsText={labelNoResults} lang={lang} />;
    $[49] = activeTab;
    $[50] = labelNoResults;
    $[51] = lang;
    $[52] = loadMoreHandler;
    $[53] = loadMoreLabel;
    $[54] = showLoadMore;
    $[55] = tabCards;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== t17 || $[58] !== t18) {
    t19 = <>{t17}{t18}</>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  return t19;
}
function _temp10(cards, filters_0) {
  const categorizedFilters = Object?.groupBy(filters_0, _temp8);
  return cards?.filter(card_4 => {
    let displayCard = false;
    const shallowCardTags_0 = card_4?.cardTags?.map(_temp9);
    Object?.values(categorizedFilters)?.every(categoryFilters => {
      displayCard = categoryFilters?.some(categoryFilter => shallowCardTags_0?.includes(categoryFilter?.id));
      if (!displayCard) {
        return false;
      } else {
        return true;
      }
    });
    return displayCard;
  });
}
function _temp9(tag_1) {
  return tag_1?.id;
}
function _temp8(t0) {
  const {
    category
  } = t0;
  return category?.id || "undefined";
}
function _temp7(tag_0) {
  return tag_0?.id;
}
function _temp6(filter) {
  return filter?.id;
}
function _temp5(typeToGather_0, card_0) {
  if (!typeToGather_0 || typeToGather_0.length === 0) {
    return true;
  }
  const checkTypes = typeToGather_0.map(_temp3).filter(_temp4);
  if (checkTypes.length === 0) {
    return true;
  }
  const cardType = card_0?.typeName;
  return checkTypes.includes(cardType);
}
function _temp4(t) {
  return !!t;
}
function _temp3(type) {
  return normalizeTabType(type);
}
function _temp2(card) {
  return card?.tagsCollection?.items?.map(_temp);
}
function _temp(tag) {
  return {
    id: tag?.sys?.id,
    title: tag?.displayName,
    category: {
      id: tag?.categoryCollection?.items[0]?.sys?.id,
      title: tag?.categoryCollection?.items[0]?.displayName
    }
  };
}